var map = {
	"./natal_1barra.webp": 6708,
	"./natal_1disco.webp": 26,
	"./natal_alema.webp": 5360,
	"./natal_boloreis.webp": 6470,
	"./natal_brigadeiro.webp": 3901,
	"./natal_brownie_morango.webp": 5243,
	"./natal_cafe.webp": 1146,
	"./natal_caramelo.webp": 9574,
	"./natal_cenoura.webp": 3677,
	"./natal_cheesecake.webp": 8533,
	"./natal_cheesecake_goiaba.webp": 9919,
	"./natal_cheesecake_nutella.webp": 5149,
	"./natal_chocolate.webp": 3807,
	"./natal_damasco.webp": 5805,
	"./natal_domino.webp": 4741,
	"./natal_donaana.webp": 2598,
	"./natal_limao.webp": 4473,
	"./natal_menta.webp": 855,
	"./natal_morango.webp": 3750,
	"./natal_mousse_brigadeiro.webp": 9865,
	"./natal_natalino.webp": 9409,
	"./natal_nozes.webp": 5402,
	"./natal_redvelvet.webp": 354,
	"./natal_seducao.webp": 6419,
	"./natal_tentacao.webp": 839,
	"./natal_tropical.webp": 508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2003;